// new = 17ef0766680d11ec90d60242ac120003
// old = 2a4c14b41df011e8b4670ed5f89f718b
import BonusGameCompleteCheck from 'desicions/bonus-game-complete-check';
import FreeSpinCompleteCheck from 'desicions/free-spin-complete-check';
import IsFreeSpinEnterCheck from 'desicions/free-spin-enter-check';
import IsFreeSpinCheck from 'desicions/freespin-check';
import TreasureBonusCheck from 'desicions/treasure-bonus-check';
import IsTreasureBonusEnterCheck from 'desicions/treasure-bonus-enter-check';
import DOBonusRecordBuilder from 'integration/bonus-record-builder';
import RecoveryRecordBuilder from 'integration/recovery-record-builder';
import DOSpinRecordBuilder from 'integration/spin-record-builder';
import * as Logger from 'js-logger';
import 'pixi.js';
import Components from 'slotworks/components/components';
import FooterComponent from 'slotworks/components/info/footer-component';
import GameLoop from 'slotworks/core/game-loop';
import ButtonElement from 'slotworks/graphics/elements/button-element';
import Layers from 'slotworks/graphics/layers/layers';
import SpinRecordBuilder from 'slotworks/integration/revolver/builders/records/spin-record-builder';
import PickRequestBuilder from 'slotworks/integration/revolver/builders/requests/pick-request-builder';
import BonusResultBuilder from 'slotworks/integration/revolver/builders/results/bonus-result-builder';
import campaignsModel from 'slotworks/integration/revolver/model/campaigns-model';
import RevolverModel from 'slotworks/integration/revolver/model/revolver-model';
import RevolverBuilders from 'slotworks/integration/revolver/revolver-builders';
import { RevolverReady } from 'slotworks/integration/revolver/revolver-setup';
import LineWinTransitions from 'slotworks/integration/revolver/transitions/line-win-transitions';
import betModel from 'slotworks/model/bets/bet-model';
import gameState from 'slotworks/model/game-state';
import settingsModel from 'slotworks/model/settings/settings-model';
import slotDefinition from 'slotworks/model/slot-definition';
import BuilderManager from 'slotworks/server/builders/builder-manager';
import SlotWorks from 'slotworks/slotworks';
import FreespinButtonBehaviour from 'slotworks/smart-button/behaviours/freespin-button-behaviour';
import HiddenButtonBehaviour from 'slotworks/smart-button/behaviours/hidden-button-behaviour';
import SmartButton, { SmartButtonFlag } from 'slotworks/smart-button/smart-button';
import WinCycle from 'slotworks/state-machine/standard/super-states/win-cycle';
import StateMachine from 'slotworks/state-machine/state-machine';
import StateRegister from 'slotworks/state-machine/state-register';
import { EnableOnScreenErrors } from 'slotworks/utils/debug';
import EnterFreeSpin from 'states/enter-freespin';
import ExitFreeSpin from 'states/exit-freespin';
import ExitTreasureBonus from 'states/exit-treasure-bonus';
import PdInit from 'states/game-init';
import Idles from 'states/idles';
import LoopWin from 'states/loop-win';
import RecoverFreeSpin from 'states/recover-freespin';
import RecoverTreasureBonus from 'states/recover-treasure-bonus';
import RequestSpins from 'states/request-spin';
import ReTriggerFreeSpin from 'states/retrigger-freespin';
import RevolverBigWin from 'states/revolver-big-win';
import ShowWinLines from 'states/show-win-line';
import SpecialSymbolCelebration from 'states/special-symbol-celebration';
import TreasureBonus from 'states/treasure-bonus';
import WildSticky from 'states/wild-sitcky';
import BigWinTransition from 'transitions/big-win-transition';
import BonusBuyTransition from 'transitions/bonus-buy-transition';
import EnterFreeSpinTransition from 'transitions/enter-freespin-transition';
import EpicWinTransition from 'transitions/epic-win-transition';
import ExitFreeSpinTransition from 'transitions/exit-freespin-transition';
import ExitTeasureBonusTransition from 'transitions/exit-treasure-transition';
import GameIntro from 'transitions/game-intro';
import MegaWinTransition from 'transitions/mega-win-transition';
import RetriggerFreeSpins from 'transitions/retrigger-freespins-transition';
import SuperMegaWinTransition from 'transitions/super-mega-win-transition';
import TotalWinTransition from 'transitions/total-win-transitions';
import WinCycles from 'transitions/win-cycle';
import { Celebration, DOPrompts, DOServerKeys, GFCustomLayers } from './names/do-names';
import graphicsManager from 'slotworks/graphics/graphics-manager';
import soundManager from 'slotworks/sound/sound-manager';
import canvasManager from 'slotworks/graphics/canvas/canvas-manager';
import IsBuyFreeSpinsCheck from 'desicions/is-buy-freespins-check';
import IsBuyBonusCheck from 'desicions/is-buy-bonus-check';
import BuyoutFreespins from 'states/buyout-freespins';
import BuyoutBonus from 'states/buyout-bonus';
import DOScatterResultBuilder from 'integration/scatter-result-builder';
import ScatterResultBuilder from 'slotworks/integration/revolver/builders/results/scatter-result-builder';
import AuthRecordBuilder from 'slotworks/integration/revolver/builders/records/auth-record-builder';
import DOAuthRecordBuilder from './integration/auth-record-builder';
import FreespinIdle from 'slotworks/state-machine/standard/states/freespin-idle';
import Autoplay from 'slotworks/state-machine/standard/states/autoplay';
import deviceInfo from 'slotworks/utils/device-info';
import BetBarResizer from 'slotworks/components/betbar/bet-bar-resizer';

declare const __DEBUG__: boolean;
declare const require: any;
const assetConfig = require('./asset-config.json');
const gameConfig = require('./game-config.json');
const stateConfig = require('./state-config.json');
const soundConfig = require('./sound-config.json');
const componentConfig = require('./component-config.json');
const i18nConfig = require('./i18n-config.json');

require('../static/styles.scss');

if (__DEBUG__) {
    Logger.useDefaults();
}

function RevolverInit() {
    FreespinIdle.WAIT = 500;
    Autoplay.WAIT = 500;
}
RevolverInit();

const ready = () => {
    setupTransitions();

    if (__DEBUG__) {
        GameLoop.showStats();
    }
    BetBarResizer.MOBILE_TEXTS_SCALE = true;
    
    RevolverReady();
    (GameLoop as any).frameSkipping = true;

    const symbols = slotDefinition.symbolDefinitions;
    settingsModel.maxWin = symbols.filter(el => el.id == 'H1')[0].payouts.get('5') / betModel.getSelectedLines();

    const campaingActive = campaignsModel.isFreespinsActive();
    for (let mask = 0; mask < SmartButtonFlag.MAX; mask++) {
        if ((mask & SmartButtonFlag.BONUS) > 0) {
            SmartButton.overrideBehaviour(mask, HiddenButtonBehaviour);
        }
        if (!campaingActive && (mask & SmartButtonFlag.FREE_SPINS) > 0) {
            SmartButton.overrideBehaviour(mask, FreespinButtonBehaviour);
        }
    }

    ButtonElement.DISABLED_TINT = 0xa9a9a9;
    ButtonElement.OVER_TINT = 0xd3d3d3;
    ButtonElement.DOWN_SCALE = 0.8;
    FooterComponent.layer = Layers.Footer;
    FreespinButtonBehaviour.HIDDEN = false;

    Layers.LayersToReposition.push(
        Layers.Custom.get('IntroPopups'),
        Layers.Prompts,
        Layers.Paylines,
        Layers.SymbolAnimations,
        Layers.MatrixBackground,
        Layers.MatrixContent,
        Layers.Custom.get(GFCustomLayers.ANTICIPATION)
    );
    Layers.LayersToReset.push(
        Layers.Bonus,       
        Layers.MatrixForeground,
        Layers.BonusForeground,
        Layers.Custom.get(GFCustomLayers.BACKGROUND_ANIMATIONS),
        Layers.Custom.get('BonusBuy')
    );
    if (!deviceInfo.isDesktop) {
        Layers.LayersToReset.push(Layers.Custom.get('Messages'));
    }
};

const setupComms = () => {
    BonusResultBuilder.bonusId = DOServerKeys.TREASURE_BONUS;
    RevolverModel.addFreespinIdentifiers([DOServerKeys.FREESPIN]);

    RevolverBuilders.init();
    BuilderManager.removeRecordBuilder(AuthRecordBuilder);
    BuilderManager.addRecordBuilder(DOAuthRecordBuilder);
    BuilderManager.addRecordBuilder(RecoveryRecordBuilder);
    BuilderManager.addRequestBuilder(PickRequestBuilder);
    BuilderManager.removeRecordBuilder(SpinRecordBuilder);
    BuilderManager.addRecordBuilder(DOBonusRecordBuilder);
    BuilderManager.addRecordBuilder(DOSpinRecordBuilder);

    BuilderManager.removeResultBuilder(ScatterResultBuilder);
    BuilderManager.addResultBuilder(DOScatterResultBuilder);
};

const setupStates = () => {
    StateRegister.add('idles', new Idles(StateMachine));
    StateRegister.add('pd-init', new PdInit(StateMachine));
    StateRegister.add('exit-freespin', new ExitFreeSpin(StateMachine));
    StateRegister.add('win-cycles', new WinCycles(StateMachine));
    StateRegister.add('treasure-bonus-check', new IsTreasureBonusEnterCheck());
    StateRegister.add('recovery-treasure-bonus-check', new TreasureBonusCheck(DOServerKeys.TREASURE_BONUS));
    StateRegister.add('free-spin-enter-check', new IsFreeSpinEnterCheck());
    StateRegister.add('freespin-check', new IsFreeSpinCheck());
    StateRegister.add('wild-sticky', new WildSticky(StateMachine));
    StateRegister.add('recovery-freespin-check', new IsFreeSpinCheck());
    StateRegister.add('revolver-big-win', new RevolverBigWin(StateMachine));
    StateRegister.add('enter-freespin', new EnterFreeSpin(StateMachine));
    StateRegister.add('exit-treasure-bonus', new ExitTreasureBonus(StateMachine));
    StateRegister.add('treasure-bonus', new TreasureBonus(StateMachine));
    StateRegister.add('treasure-bonus-celebration', new SpecialSymbolCelebration(StateMachine, 'BN'));
    StateRegister.add('freespin-celebration', new SpecialSymbolCelebration(StateMachine, 'SC'));
    StateRegister.add('retrigger-freespin', new ReTriggerFreeSpin(StateMachine, 'SC'));
    StateRegister.add('recover-treasure-bonus', new RecoverTreasureBonus(StateMachine));
    StateRegister.add('recover-bonus-game', new RecoverFreeSpin(StateMachine));
    StateRegister.add('recover-freespin', new RecoverFreeSpin(StateMachine));
    StateRegister.add('loop-win', new LoopWin(StateMachine));
    StateRegister.add('show-win-line', new ShowWinLines(StateMachine));
    StateRegister.add('request-spins', new RequestSpins(StateMachine));
    StateRegister.add('free-spin-complete-check', new FreeSpinCompleteCheck());
    StateRegister.add('bonus-game-complete-check', new BonusGameCompleteCheck());
    StateRegister.add('win-cycle', new WinCycle(StateMachine));

    StateRegister.add('buyout-freespins', new BuyoutFreespins(StateMachine));
    StateRegister.add('buyout-bonus', new BuyoutBonus(StateMachine));
    StateRegister.add('is-buy-freespins-check', new IsBuyFreeSpinsCheck());
    StateRegister.add('is-buy-bonus-check', new IsBuyBonusCheck());
};

const setupTransitions = () => {
    Layers.CelebrationContent.setTransitions(Celebration.TOTAL_WIN, new TotalWinTransition());
    Layers.CelebrationContent.setTransitions(Celebration.BIG_WIN, new BigWinTransition());
    Layers.CelebrationContent.setTransitions(Celebration.SUPER_MEGA_WIN, new SuperMegaWinTransition());
    Layers.CelebrationContent.setTransitions(Celebration.MEGA_WIN, new MegaWinTransition());
    Layers.CelebrationContent.setTransitions(Celebration.EPIC_WIN, new EpicWinTransition());
    Layers.Prompts.setTransitions(DOPrompts.EXIT_TREASURE_BONUS, new ExitTeasureBonusTransition());
    Layers.Prompts.setTransitions(DOPrompts.RETRIGGER_FREESPIN, new RetriggerFreeSpins());
    Layers.Prompts.setTransitions(DOPrompts.EXIT_FREESPIN, new ExitFreeSpinTransition());
    Layers.Prompts.setTransitions(DOPrompts.ENTER_FREESPIN, new EnterFreeSpinTransition());
    Layers.Prompts.setTransitions(DOPrompts.GAME_INTRO, new GameIntro());
    Layers.Prompts.setTransitions('bonusbuy', new BonusBuyTransition());

    for (let row = 1; row <= 4; row++) {
        if (Layers.CelebrationContent.hasScene(`line_row_${row}_win`)) {
            Layers.CelebrationContent.setTransitions(`line_row_${row}_win`, new LineWinTransitions());
        }
    }
};

setupComms();
setupStates();

SlotWorks.go(gameConfig, stateConfig, assetConfig, componentConfig, soundConfig, i18nConfig, ready);
Layers.Custom.get('Poster').container.parent.setChildIndex(Layers.Custom.get('Poster').container, 30);

if (__DEBUG__) {
    EnableOnScreenErrors();
}



// WEBPACK FOOTER //
// ./src/app.ts